import { PropsWithChildren } from "react";
import KioskControls from "./KioskControls";
import Main from "./Main";
import { Sidebar } from "./Sidebar/Sidebar";
import Topbar from "./Topbar";

export const DefaultPage = ({
    children,
    kiosk = false,
}: {
    children: PropsWithChildren<{}>;
    kiosk?: boolean;
}) => {
    // Kiosk / fullscreen mode: hide the Console chrome (top bar + quick-access
    // sidebar) so the routed screen fills the viewport. A floating control lets
    // the user leave again (see KioskControls).
    if (kiosk) {
        return (
            <div className="page-container page-container--kiosk">
                <Main>{children}</Main>
                <KioskControls />
            </div>
        );
    }
    return (
        <div className="app-shell">
            <Topbar />
            <div className="page-container">
                <Sidebar />
                <Main>{children}</Main>
            </div>
        </div>
    );
};
